export class GetUserPermission {
  public static readonly type: string = '[Permissions] Get Permissions';
  constructor(public resourceId: number, public actionId: number) { }
}
